const SET_CURRENCY = 'SET_CURRENCY';

export { SET_CURRENCY };
